/*
 * Description: Display Image Web Component
 * Purpose: Displays a responsive image with optional caption
 * Author: Nuvemx
 * Created: 2026
 *
 * Features:
 * - Responsive image with Bootstrap img-fluid
 * - Optional caption via figcaption
 * - Configurable width and height
 *
 * Usage:
 * <display-image src="photo.jpg" alt="Description" caption="Photo caption"></display-image>
 * <display-image src="logo.png" alt="Logo" width="200"></display-image>
 *
 * Attributes:
 * - src: String - Image source URL (required)
 * - alt: String - Alt text (required)
 * - caption: String - Optional caption text
 * - width: String - Image width
 * - height: String - Image height
 *
 */

class display_image extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const src = this.getAttribute('src') || '';
        const alt = this.getAttribute('alt') || '';
        const caption = this.getAttribute('caption');
        const width = this.getAttribute('width');
        const height = this.getAttribute('height');

        const widthAttr = width ? `width="${width}"` : '';
        const heightAttr = height ? `height="${height}"` : '';
        const widthStyle = width ? `width: ${width}${/^\d+$/.test(width) ? 'px' : ''};` : '';
        const heightStyle = height ? `height: ${height}${/^\d+$/.test(height) ? 'px' : ''};` : '';
        const sizeStyle = (widthStyle || heightStyle) ? ` style="${widthStyle}${heightStyle}"` : '';
        const captionHtml = caption
            ? `<figcaption class="figure-caption text-center mt-2">${caption}</figcaption>`
            : '';

        this.innerHTML = `
            <figure class="figure text-center">
                <img src="${src}" alt="${alt}" class="figure-img img-fluid rounded" ${widthAttr} ${heightAttr}${sizeStyle}>
                ${captionHtml}
            </figure>`;
        this.dataset.rendered = "true";
    }
}

export { display_image };
